var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.title,"disabled":!_vm.title,"placement":"top"}},[_c('span',{staticClass:"resumo-tag",class:_vm.statusClass},[_c('i',{staticClass:"resumo-tag-icon",class:_vm.statusIcon}),_vm._v(_vm._s(_vm.$t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${_vm.status}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }